module.exports = __webpack_public_path__ + "img/tooltip-vallone-como-gunmetal-01.a8ba167b.jpg";